import React from 'react'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import { FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { useGlobalStoreData } from '../../../../../../src/store/globalStore'

const EmailSignatureSection = ({
  control,
  fieldPrefix = 'emailSignatureFileId'
}) => {
  const { t } = useTranslation()
  const user = useGlobalStoreData.user()
  const signatures = user?.emailSignatureFiles || []

  return (
    <>
      <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 4, mb: 3 }}>
        {t('mailTemplate.wizard.ai.emailSignature') || 'Email Signature'}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Controller
            name={fieldPrefix}
            control={control}
            defaultValue=""
            render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
              <FormControl fullWidth error={!!error} size="small">
                <InputLabel>{t('mailTemplate.wizard.ai.selectSignature') || 'Select Signature'}</InputLabel>
                <Select
                  inputRef={ref}
                  value={value || ''}
                  onChange={onChange}
                  label={t('mailTemplate.wizard.ai.selectSignature') || 'Select Signature'}
                  sx={{
                    height: 40
                  }}
                >
                  <MenuItem value="">
                    <em>{t('common.none') || 'None'}</em>
                  </MenuItem>
                  {signatures.map((sig) => (
                    <MenuItem key={sig.id} value={sig.id}>
                      {sig.fileName || `Signature (${sig.id.substring(0, 8)})`}
                    </MenuItem>
                  ))}
                </Select>
                {error && <Typography variant="caption" color="error" sx={{ ml: 2 }}>{error.message}</Typography>}
              </FormControl>
            )}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default EmailSignatureSection
